export const ALERT = {
  KIND: {
    SUCCESS: "success",
    DANGER: "danger",
    WARNING: "warning",
    PRIMARY: "primary",
  },
};